interface PreviewDocument {
  file: number;
  file_url?: string;
  content_type?: string;
  media_kind?: string;
}

export function documentPreview(document: PreviewDocument) {
  const url = document.file_url?.trim() || `/api/media/${document.file}/download/`;
  const isImage = document.content_type
    ? document.content_type.startsWith('image/')
    : document.media_kind !== 'document';
  return { url, isImage, thumbnail: `${url}${url.includes('?') ? '&' : '?'}preview=128` };
}
